<template>
  <div class='p-2 border rounded-md bg-white'>
    <textarea class='w-full p-1 border rounded'
      rows='3'
      v-model='commentBody'
      :placeholder='createInputPlaceholderMessage'></textarea>
    <div class='flex flex-row justify-end'>
      <button class='border text-center px-4 py-2 rounded text-sm text-white font-semibold'
        style='background-color: var(--eventMainColor);'
        :class='commentSubmitButtonClass'
        :disabled='!hasCommentBody'
        @click='submitComment'>
        {{submitButtonText}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import axios  from 'axios'
import camelcaseKeys from 'camelcase-keys'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: 'PublicSessionCommentCreateInput',
  props: ['parentCommentId'],
  data() {
    return {
      commentBody: ''
    }
  },
  computed: {
    ...mapState('comments', [
      'instance'
    ]),
    ...mapGetters('events', [
      'showingEventId',
      'showTextInKorean',
    ]),
    ...mapGetters('events', [
      'showingEventSessionPageConfigurations',
    ]),
    publicSessionAccessToken () {
      return this.showingEventSessionPageConfigurations && this.showingEventSessionPageConfigurations.publicSessionAccessToken ? this.showingEventSessionPageConfigurations.publicSessionAccessToken : ''
    },
    hasCommentBody () {
      return this.commentBody
    },
    commentSubmitButtonClass () {
      return this.hasCommentBody ? '' : 'opacity-25'
    },
    commentParams () {
      return {
        comment: {
          body: this.commentBody,
          instance_type: this.instance.type,
          instance_id: this.instance.id,
          parent_comment_id: this.parentCommentId,
          event_id: this.showingEventId
        }
      }
    },
    createInputPlaceholderMessage () {
      if (this.showTextInKorean) {
        if (this.parentCommentId) {
          return '질의 사항의 댓글을 입력해 주십시오.'
        } else {
          return '강의에 대하여 궁금한 점을 기재해 주십시오.'
        }
      } else {
        return ''
      }
    },
    successMessage () {
      if (this.showTextInKorean) {
        if (this.parentCommentId) {
          return '댓글이 등록되었습니다.'
        } else {
          return '질의 사항이 등록되었습니다.'
        }
      } else {
        if (this.parentCommentId) {
          return 'Your question has been updated.'
        } else {
          return 'Your question has been added.'
        }
      }
    },
    submitButtonText () {
      if (this.showTextInKorean) {
        if (this.parentCommentId) {
          return '댓글 남기기'
        } else {
          return '질문하기'
        }
      } else {
        return 'Submit'
      }
    },
  },
  methods: {
    ...mapMutations('comments', [
      'updateSingleComment',
    ]),
    clearCommentBody () {
      this.commentBody = ''
    },
    publicApiBase (publicSessionAccessToken) {
      return axios.create({
        baseURL: `${process.env.VUE_APP_API}/api/v1`,
        headers: {
          Authorization: {
            toString () {
              return publicSessionAccessToken
            }
          },
          'Content-Type': 'application/json; charset=utf-8',
          'Channel': window.location.host.replace('www.','').split('.')[0]
        }
      })
    },
    submitComment () {
      return new Promise(resolve => {
        this.publicApiBase(this.publicSessionAccessToken).post(`/comments`, this.commentParams).then(resp => resp.data).then(resp => {
          let newComment = camelcaseKeys(resp.comment, {deep: true})
          newComment.createdAt = dayjs().tz('Asia/Seoul').format()
          this.updateSingleComment(newComment)
          this.clearCommentBody()
          this.$message({
            type: 'success',
            message: this.successMessage,
          })
          resolve()
        })
      })
    },
  }
}

</script>
